<template>
  <div class="d-flex align-center justify-center login-container">
    <v-card
      width="344"
      class="mx-auto text-center login-card"
    >
      <v-card-title class="justify-center my-5">Adminisztrátor belépés</v-card-title>
      <v-card-text>

        <v-form v-model="valid">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="password"
                  :rules="[rules.required]"
                  :type="'password'"
                  name="password"
                  label="Jelszó"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn @click="login()" text>Belépés</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "@firebase/storage";
import "@firebase/auth";

export default {
  data: () => ({
    valid: false,
    email: "",
    emailRules: [
      v => !!v || "Kötelező",
      v => /.+@.+/.test(v) || "Helytelen e-mail cím"
    ],
    password: "",
    rules: {
      required: value => !!value || "Kötelező"
    }
  }),
  methods:{
    login: function() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        () => {
          this.$router.replace('admin');
        },
        (err) => {
          alert('Nem sikerült a bejelentkezés');
          console.log(err);
        }
      )
    }
  }
};
</script>

<style scoped>
.login-container {
  height: 95vh;
  width: 100vw;
}
.text-center {
  text-align: center !important;
}
.login-card {
  background-color: #334052 !important;
}
</style>